import { Slide } from "@jelly/lesson";

import { task as task06 } from "../../../../../task/course-03/lesson-04/task-06";

const task: Slide = {
  descriptionHtml:
    "We want to compute the response of a LTI system based on its time domain impulse response and the time domain<br>input signal. Please complete the Frequency Domain Method with the diffent items",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task06.id,
        },
      },
    },
  },
};

export default task;
